
import React from "react";
import Register from "@/components/Register";

const RegisterPage: React.FC = () => <Register />;

export default RegisterPage;
